import { useContext, useState, useCallback } from 'react'
import { TemplateContext } from '~/components/Template/context'
import { DrawerMenuContext } from '~/components/DrawerMenu/context'
import { getFiltersCheckout } from '~/services/api'
import { useMount } from '~/hooks'
import { showToast } from '@provi/provi-components'

export const useFinancialFlowDashboard = () => {
  const { isMobile } = useContext(TemplateContext)
  const { drawerWidth } = useContext(DrawerMenuContext)
  const [productsFilter, setProductsFilter] = useState([])
  const [selectedProducts, setSelectedProducts] = useState(null)
  const [filters, setFilters] = useState(null)

  useMount(async () => {
    getProducts()
    onFilter()
  })

  const getProducts = useCallback(async () => {
    try {
      const filtered = await getFiltersCheckout()
      const courses = filtered?.data?.result?.courses || []

      const productsFiltered = courses
        .filter((item) => item.id)
        .map((item) => {
          return {
            label: `${item.name}-${item.id}`,
            value: item.id,
            active: true,
          }
        })

      setProductsFilter(productsFiltered)
    } catch (error) {
      showToast('Um erro inesperado aconteceu')
    }
  }, [setProductsFilter])

  const onFilter = (products) => {
    const newProducts = products || []
    const filtered = {
      productsSelected: newProducts ? newProducts.map((e) => e.value) : [],
    }
    setFilters(filtered)
  }

  return {
    isMobile,
    drawerWidth,
    productsFilter,
    setProductsFilter,
    selectedProducts,
    setSelectedProducts,
    onFilter,
    filters,
  }
}
